var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BjDrawerForm",
    {
      ref: "BjDrawerForm",
      attrs: {
        form: _vm.form,
        "label-position": "top",
        rules: _vm.rules,
        "label-width": "600px",
        width: "600px",
      },
      on: { handleConfirm: _vm.handleConfirm },
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.WoodenStandardQty"),
                prop: "standardPallet",
              },
            },
            [
              _c("BjInputNumber", {
                staticClass: "full-width",
                attrs: { controls: false },
                model: {
                  value: _vm.form.standardPallet,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "standardPallet", $$v)
                  },
                  expression: "form.standardPallet",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.ChepPalletQty"),
                prop: "chepPallet",
              },
            },
            [
              _c("BjInputNumber", {
                staticClass: "full-width",
                attrs: { controls: false },
                model: {
                  value: _vm.form.chepPallet,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "chepPallet", $$v)
                  },
                  expression: "form.chepPallet",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.LoscamPalletQty"),
                prop: "loscomPallet",
              },
            },
            [
              _c("BjInputNumber", {
                staticClass: "full-width",
                attrs: { controls: false },
                model: {
                  value: _vm.form.loscomPallet,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "loscomPallet", $$v)
                  },
                  expression: "form.loscomPallet",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("billingPage.CSGPalletQty"),
                prop: "csgPallet",
              },
            },
            [
              _c("BjInputNumber", {
                staticClass: "full-width",
                attrs: { controls: false },
                model: {
                  value: _vm.form.csgPallet,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "csgPallet", $$v)
                  },
                  expression: "form.csgPallet",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("WarehouseManagement.form.Description"),
                prop: "remark",
              },
            },
            [
              _c("BjTextarea", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("WarehouseManagement.form.Description"),
                },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }